export default __webpack_public_path__ + "static/media/spot-prov-vert.e246436f.jpg";